const placementData = [
  {
    company: "Celebal Technologies",
    type: "SLI + FTE",
    roles: "Data Science, Data Engineer",
    ctc: 7.0,
    stipend: 14000,
    placed: 11,
    status: "Completed",
  },
  {
    company: "Myntra (OFF)",
    type: "SLI + FTE",
    roles: "SDE",
    ctc: 30.0,
    stipend: 70000,
    placed: 1,
    status: "Completed",
  },
  {
    company: "Goldman Sachs (OFF)",
    type: "SLI + FTE",
    roles: "SDE Analyst",
    ctc: 31.0,
    stipend: 175000,
    placed: 1,
    status: "Completed",
  },
  {
    company: "deloitte",
    type: "FTE",
    roles: "mendix developer",
    ctc: 7.6,
    stipend: 0,
    placed: 0,
    status: "Pending",
  },
  {
    company: "ProcMart",
    type: "SLI",
    roles: "Product Analyst Intern",
    ctc: 6,
    stipend: 20000,
    placed: 2,
    status: "Completed",
  },
  {
    company: "TruEsate",
    type: "SLI",
    roles: "SDE Intern",
    ctc: 9,
    stipend: 40000,
    placed: 4,
    status: "Completed",
  },
  {
    company: "Evigway Technologies",
    type: "SLI + FTE",
    roles: "SDE Intern",
    ctc: 8,
    stipend: 30000,
    placed: 0,
    status: "Pending",
  },
  
  {
    company: "Evam Labs",
    type: "SLI + FTE",
    roles: "AI/ML Research, Software & Data Engineering, Product & Operations, and Business Development",
    ctc: 10,
    stipend: 35000,
    placed: 0,
    status: "Pending",
  },
  {
    company: "Signzy",
    type: "SLI + FTE",
    roles: "Frontend Engineer",
    ctc: 10,
    stipend: 40000,
    placed: 0,
    status: "Pending",
  },
  {
    company: "Hero Vired",
    type: "SLI + FTE",
    roles: "Full Stack Engineer and Data Engineer",
    ctc: 8.5,
    stipend: 30000,
    placed: 4,
    status: "Completed",
  },
  {
    company: "Go Daddy",
    type: "SLI",
    roles: "SDE",
    ctc: 46,
    stipend: 50000,
    placed: 2,
    status: "Completed",
  },
  {
    company: "miimansa systems",
    type: "SLI+FTE",
    roles: "NLP intern",
    ctc: 12,
    stipend: 35000,
    placed: 6,
    status: "Completed",
  },
  {
    company: "Mamaearth",
    type: "SLI+FTE",
    roles: "analyst",
    ctc: 10.0,
    stipend: 25000,
    placed: 3,
    status: "Completed",
  },
  {
    company: "Unicommerce",
    type: "SLI",
    roles: "SWE(frontend)",
    ctc: 15,
    stipend: 30000,
    placed: 5,
    status: "Completed",
  },
  {
    company: "Flexport ",
    type: "SLI",
    roles: "SDE",
    ctc: 63.0,
    stipend: 125000,
    placed: 2,
    status: "Completed",
  },
  
  {
    company: "blogvault",
    type: "SLI+FTE",
    roles: "SDE",
    ctc: 12,
    stipend: 30000,
    placed: 0,
    status: "Completed",
  },
  {
    company: "NAV Consulting",
    type: "SLI + FTE",
    roles: "SWE",
    ctc: 11,
    stipend: 25000,
    placed: 3,
    status: "Completed",
  },
  {
    company: "Amazon (off)",
    type: "SLI",
    roles: "SDE",
    ctc: 47.0,
    stipend: 110000,
    placed: 1,
    status: "Completed",
  },
  {
    company: "Ador",
    type: "SLI+FTE",
    roles: "core engineer",
    ctc: 9.0,
    stipend: 25000,
    placed: 2,
    status: "Completed",
  },
  {
    company: "JIO (off)",
    type: "SLI",
    roles: "SDE",
    ctc: 18.5,
    stipend: 50000,
    placed: 1,
    status: "Completed",
  },
  {
    company: "FreeCharge",
    type: "SLI + FTE",
    roles: "Devops, Data engineer, QA, Frontend, Backend",
    ctc: 7.0,
    stipend: 25000,
    placed: 8,
    status: "Completed",
  },
  {
    company: "Provakil",
    type: "SLI + FTE",
    roles: "Associate Software Developer",
    ctc: 6.5,
    stipend: 20000,
    placed: 2,
    status: "Completed",
  },
  {
    company: "Kickdrum",
    type: "SLI + FTE",
    roles: "Software Developer",
    ctc: 15,
    stipend: 35000,
    placed: 2,
    status: "Completed",
  },
  {
    company: "hashedin(deloitte)",
    type: "SLI+FTE",
    roles: "Software engineer",
    ctc: 8.1,
    stipend: 25000,
    placed: 2,
    status: "Completed",
  },
  {
    company: "ShodhAI",
    type: "SLI + FTE",
    roles: "ML, Fullstack, SRE",
    ctc: 15.0,
    stipend: 15000,
    placed: 4,
    status: "Completed",
  },
  {
    company: "Unicommerce",
    type: "SLI + FTE",
    roles: "Enterprise Onboarding Profile",
    ctc: 5.5,
    stipend: 25000,
    placed: 4,
    status: "Completed",
  },
  {
    company: "Nagarro Software",
    type: "SLI + FTE",
    roles: "Full Stack Developer",
    ctc: 7.0,
    stipend: 30000,
    placed: 4,
    status: "Completed",
  },
  {
    company: "TITAN.email",
    type: "SLI + FTE",
    roles: "SDE",
    ctc: 25.0,
    stipend: 100000,
    placed: 0,
    status: "Completed",
  },
  {
    company: "Treebo Hotels",
    type: "SLI + FTE",
    roles: "Backend Developer",
    ctc: 12.5,
    stipend: 25000,
    placed: 2,
    status: "Completed",
  },
  {
    company: "Treebo Hotels",
    type: "SLI + FTE",
    roles: "SDET",
    ctc: 9.5,
    stipend: 15000,
    placed: 1,
    status: "Completed",
  },
  {
    company: "Treebo Hotels",
    type: "SLI + FTE",
    roles: "SRE",
    ctc: 7.0,
    stipend: 15000,
    placed: 3,
    status: "Completed",
  },
  {
    company: "Spring Financial",
    type: "SLI + FTE",
    roles: "Software Engineer Trainee",
    ctc: 12.0,
    stipend: 25000,
    placed: 2,
    status: "Completed",
  },
  {
    company: "APMSE(Eagleview)",
    type: "SLI + FTE",
    roles: "SDE",
    ctc: 12.84,
    stipend: 50000,
    placed: 7,
    status: "Completed",
  },
  {
    company: "ZS Associates",
    type: "SLI + FTE",
    roles: "Software Developer, Business Analyst, DAA",
    ctc: 14.15,
    stipend: 43000,
    placed: 23,
    status: "Completed",
  },
  {
    company: "DEShaw",
    type: "SLI + FTE",
    roles: "SDET",
    ctc: 59.3,
    stipend: 150000,
    placed: 3,
    status: "Completed",
  },
  {
    company: "EPAM",
    type: "SLI + FTE",
    roles: "Tech Role",
    ctc: 8.48,
    stipend: 27500,
    placed: 2,
    status: "Completed",
  },
  {
    company: "ProcDNA",
    type: "SLI + FTE",
    roles: "Business Analyst, Data Science",
    ctc: 16.74,
    stipend: 25000,
    placed: 2,
    status: "Completed",
  },
  {
    company: "Media.net",
    type: "SLI + FTE",
    roles: "SDE",
    ctc: 39.3,
    stipend: 100000,
    placed: 1,
    status: "Completed",
  },
  {
    company: "Media.net",
    type: "SLI",
    roles: "SDE",
    ctc: 39.3,
    stipend: 100000,
    placed: 1,
    status: "Completed",
  },
  {
    company: "Triology",
    type: "FTE",
    roles: "SDE",
    ctc: 32.5,
    stipend: 0,
    placed: 0,
    status: "Completed",
  },
  {
    company: "E2E Networks",
    type: "SLI + FTE",
    roles: "Associate Software Engineer",
    ctc: 13.0,
    stipend: 48200,
    placed: 5,
    status: "Completed",
  },
  {
    company: "Flipkart",
    type: "SLI + FTE",
    roles: "NEEV(Supply Chain)",
    ctc: 14.5,
    stipend: 50000,
    placed: 3,
    status: "Completed",
  },
  {
    company: "Tekion",
    type: "SLI + FTE",
    roles: "Associate Software Engineer",
    ctc: 20.0,
    stipend: 65000,
    placed: 5,
    status: "Completed",
  },
  {
    company: "Whatfix(Quiko)",
    type: "SLI + FTE",
    roles: "Software Engineer",
    ctc: 16.0,
    stipend: 50000,
    placed: 4,
    status: "Completed",
  },
  {
    company: "Eatclub",
    type: "SLI + FTE",
    roles: "SDE",
    ctc: 22.0,
    stipend: 40000,
    placed: 5,
    status: "Completed",
  },
  {
    company: "MakeMyTrip",
    type: "SLI + FTE",
    roles: "Software Engineer",
    ctc: 22.0,
    stipend: 50000,
    placed: 2,
    status: "Completed",
  },
  {
    company: "Sprinklr",
    type: "SLI + FTE",
    roles: "Cloud Engineer",
    ctc: 18.0,
    stipend: 75000,
    placed: 2,
    status: "Completed",
  },
  {
    company: "Addverb Technologies",
    type: "SLI + FTE",
    roles: "Software Developer, Mobile Robotics",
    ctc: 16.0,
    stipend: 25000,
    placed: 2,
    status: "Completed",
  },
  {
    company: "Triumph Motorcycles",
    type: "SLI + FTE",
    roles: "Graduate Engineer Trainee",
    ctc: 12.5,
    stipend: 50000,
    placed: 2,
    status: "Completed",
  },
  {
    company: "Addverb Technologies",
    type: "SLI",
    roles: "Software Developer, Mobile Robotics",
    ctc: 16.0,
    stipend: 25000,
    placed: 4,
    status: "Completed",
  },
  {
    company: "Triumph Motorcycles",
    type: "SLI",
    roles: "Graduate Engineer Trainee",
    ctc: 12.5,
    stipend: 50000,
    placed: 2,
    status: "Completed",
  },
  {
    company: "Agoda (off campus)",
    type: "SLI ",
    roles: "SWE Intern",
    ctc: 25,
    stipend: 55000,
    placed: 1,
    status: "Completed",
  },
  {
    company: "BNY Mellon",
    type: "SLI + FTE",
    roles: "SDE",
    ctc: 22.0,
    stipend: 75000,
    placed: 3,
    status: "Completed",
  },
  {
    company: "Regodit (off campus)",
    type: "SLI + FTE",
    roles: "SDE",
    ctc: 12.0,
    stipend: 30000,
    placed: 1,
    status: "Completed",
  },
  {
    company: "Coinswitch (off campus)",
    type: "SLI + FTE",
    roles: "SDE",
    ctc: 36.7,
    stipend: 80000,
    placed: 1,
    status: "Completed",
  },
  {
    company: "Kuki Solutions (off campus)",
    type: "SLI+FTE",
    roles: "SDE",
    ctc: 11.25,
    stipend: 93750,
    placed: 1,
    status: "Completed",
  },
  {
    company: "Fenix Commerce (off campus)",
    type: "SLI",
    roles: "SDE",
    ctc: 12.0,
    stipend: 60000,
    placed: 1,
    status: "Completed",
  },
  {
    company: "Allen Digital (off campus)",
    type: "SLI + FTE",
    roles: "SDE",
    ctc: 21.9,
    stipend: 75000,
    placed: 1,
    status: "Completed",
  },
  {
    company: "Deloitte",
    type: "SLI + FTE",
    roles: "Product Engineer, DataScience, UI/UX",
    ctc: 12.64,
    stipend: 30000,
    placed: 16,
    status: "Completed",
  },
  {
    company: "OneBanc",
    type: "SLI+FTE",
    roles: "Android, IOS, Full Stack, UI/UX",
    ctc: 12.0,
    stipend: 40000,
    placed: 1,
    status: "Completed",
  },
  {
    company: "Curiflow",
    type: "SLI+FTE",
    roles: "Frontend Developer, SDE",
    ctc: 15.0,
    stipend: 60000,
    placed: 4,
    status: "Completed",
  },
  {
    company: "Aperam",
    type: "SLI + FTE",
    roles: "AI & Automation, Data Engineer",
    ctc: 11.5,
    stipend: 30000,
    placed: 4,
    status: "Completed",
  },
  {
    company: "AMD",
    type: "SLI + FTE",
    roles: "Software and Hardware Engineer",
    ctc: 26.1,
    stipend: 50000,
    placed: 0,
    status: "Completed",
  },
  {
    company: "GoDaddy",
    type: "SLI + FTE",
    roles: "Product Manager",
    ctc: 28.5,
    stipend: 40000,
    placed: 1,
    status: "Completed",
  },
  {
    company: "HSBC",
    type: "FTE",
    roles: "Trainee Software Engineer",
    ctc: 16.43,
    stipend: 0,
    placed: 0,
    status: "Completed",
  },
  {
    company: "Samsung Noida",
    type: "SLI ",
    roles: "R & D",
    ctc: 15.5,
    stipend: 50000,
    placed: 4,
    status: "Completed",
  },
  {
    company: "Samsung (delhi)",
    type: "SLI",
    roles: "R & D",
    ctc: 15.5,
    stipend: 50000,
    placed: 9,
    status: "Completed",
  },
  {
    company: "Media.net",
    type: "SLI",
    roles: "SRE",
    ctc: 14.5,
    stipend: 100000,
    placed: 1,
    status: "completed",
  },
  {
    company: "Josh Technology Group",
    type: "SLI + FTE",
    roles: "Associate Software Developer",
    ctc: 10.78,
    stipend: 22500,
    placed: 0,
    status: "Completed",
  },
  {
    company: "Josh Technology Group",
    type: "SLI + FTE",
    roles: "Software Quality Analyst",
    ctc: 5.39,
    stipend: 20000,
    placed: 0,
    status: "Completed",
  },
  {
    company: "Park+",
    type: "SLI + FTE",
    roles: "SDE - 1 Backend",
    ctc: 30.0,
    stipend: 30000,
    placed: 0,
    status: "Pending",
  },
  {
    company: "Eucloid",
    type: "SLI",
    roles: "Data Solutions Associate Intern",
    ctc: 8.5,
    stipend: 35000,
    placed: 6,
    status: "Completed",
  },
  {
    company: "ION",
    type: "SLI +FTE",
    roles: "SDE, Data Scientist, Tech-Analyst",
    ctc: 17.3,
    stipend: 125000,
    placed: 1,
    status: "Completed",
  },
  {
    company: "rtCamp",
    type: "Intern + FTE",
    roles: "Associate Software Engineer",
    ctc: 13.0,
    stipend: 25000,
    placed: 0,
    status: "Completed",
  },
  {
    company: "Honda Cars",
    type: "SLI + FTE",
    roles: "Graduate Engineer Trainee",
    ctc: 6.0,
    stipend: 20000,
    placed: 1,
    status: "Completed",
  },
  {
    company: "Manthhan",
    type: "SLI + FTE",
    roles: "ML, SDE, BA",
    ctc: 7,
    stipend: 25000,
    placed: 4,
    status: "Completed",
  },
  {
    company: "MAVQ",
    type: "SLI + FTE",
    roles: "",
    ctc: 14.3,
    stipend: 30000,
    placed: 4,
    status: "Completed",
  },
  {
    company: "Innovaccer",
    type: "SLI + FTE",
    roles: "data analyst",
    ctc: 10.0,
    stipend: 40000,
    placed: 11,
    status: "Completed",
  },
  {
    company: "Dell (Off-Campus)",
    type: "FTE",
    roles: "SDE",
    ctc: 25.0,
    stipend: 0,
    placed: 1,
    status: "Completed",
  },
  {
    company: "Greenlight (Off-Campus)",
    type: "FTE",
    roles: "SDE",
    ctc: 40.0,
    stipend: 0,
    placed: 1,
    status: "Completed",
  },
  {
    company: "Google (Off-Campus)",
    type: "SLI + FTE",
    roles: "SDE",
    ctc: 53.13,
    stipend: 150000,
    placed: 1,
    status: "Completed",
  },
  {
    company: "Microsoft (Off-Campus)",
    type: "FTE",
    roles: "SDE",
    ctc: 55.9,
    stipend: 0,
    placed: 1,
    status: "Completed",
  },
  {
    company: "Swiggy (Off-Campus)",
    type: "FTE",
    roles: "ASDE",
    ctc: 8.3,
    stipend: 0,
    placed: 1,
    status: "Completed",
  },
  {
    company: "Kaabil Finance",
    type: "SLI + FTE",
    roles: "SWE",
    ctc: 12,
    stipend: 25000,
    placed: 6,
    status: "Completed",
  },
  {
    company: "BTC",
    type: "SLI + FTE",
    roles: "not known yet",
    ctc: 12.00,
    stipend: 35000,
    placed: 1,
    status: "Completed",
  },
  {
    company: "BTC",
    type: "SLI + FTE",
    roles: "AI engineer",
    ctc: 7.21,
    stipend: 25000,
    placed: 1,
    status: "Completed",
  },
  {
    company: "Axcestrack",
    type: "SLI + FTE",
    roles: "SDET",
    ctc: 6,
    stipend: 20000,
    placed: 1,
    status: "Completed",
  },
  {
    company: "BOT Consulting",
    type: "SLI + FTE",
    roles: "AI Engineer ",
    ctc: 7.21,
    stipend: 25000,
    placed: 1,
    status: "Completed",
  },
  {
    company: "Trisx Technologies Pvt. Ltd. (OFF)",
    type: "SLI + FTE",
    roles: "SDE",
    ctc: 10,
    stipend: 25000,
    placed: 2,
    status: "Completed",
  },
  {
    company: "Layer 3 Inc. (OFF)",
    type: "SLI ",
    roles: "web3",
    ctc: 12,
    stipend: 50000,
    placed: 1,
    status: "Completed",
  },
  {
    company: "OTSI",
    type: "SLI + FTE",
    roles: "AI & FULLSTACK",
    ctc: 12,
    stipend: 25000,
    placed: 1,
    status: "Completed",
  },
  {
    company: "Saint Fox (off campus)",
    type: "SLI + FTE",
    roles: "SDE",
    ctc: 12,
    stipend: 25000,
    placed: 1,
    status: "Completed",
  },
  {
    company: "serent corporation ",
    type: "SLI+FTE",
    roles: "NLP intern",
    ctc: 12,
    stipend: 40000,
    placed: 3,
    status: "Completed",
  },
  {
    company: "Thingliasta automation (OFF)",
    type: "SLI",
    roles: "SDE",
    ctc: 9,
    stipend: 20000,
    placed: 1,
    status: "Completed",
  },
  {
    company: "Saturn IQ (OFF)",
    type: "SLI",
    roles: "SDE",
    ctc: 9,
    stipend: 25000,
    placed: 1,
    status: "Completed",
  },
];

export default placementData;
